import './style.css'
import {mdiFacebook, mdiInstagram, mdiWhatsapp} from '@mdi/js';
import Icon from "@mdi/react";
import logo from '../../assets/logocaps.png';

function Footer(){
    return(
        <footer>
            <div className="footer-container">
                <div className="menu-footer">
                    <h1>Loja</h1>
                    <a href="#top">Início</a>
                    <a href="#products">Produtos</a>
                    <a href="#clients">Clientes</a>
                    <a href="#who-are">Sobre</a>
                    <a href="#contact">Contato</a>
                </div>
                <div className="menu-footer">
                    <h1>Redes Socias</h1>
                    <a href="https://www.instagram.com/capsstorepersonalizados/" target='_blank'><Icon path={mdiInstagram} /></a>
                    <a href="https://www.facebook.com/capsstorepersonalizados" target='_blank'><Icon path={mdiFacebook} /></a>
                    <a href="https://tintim.link/whatsapp/ae03a87e-b199-4b16-aed3-9bbcd95068c3/b3902c37-9caa-4a35-ae7b-d62e317a3e6b" target="_blank"><Icon path={mdiWhatsapp} /></a>
                </div>
                <div className="menu-footer">
                    <img src={logo} alt=""/>
                </div>
            </div>
            <p>GST6001 PERSONALIZADOS LTDA. CNPJ 62.299.702/0001-75 | Rua 970, n° 238 | Bairro Centro | CEP 88330-588 | Balneário Camboriú | SC | Brasil</p>
            <p>© Caps Store Brazil - {new Date().getFullYear()}</p>
        </footer>
    )
}

export default Footer;